var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsletterWidget2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_72_2713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.595032C0 0.595032 7.2 57.124 15 57.124C22.2 57.124 22.2 38.6777 30 38.6777C37.2 38.6777 37.2 34.5124 45 34.5124C52.2 34.5124 60 52.9587 60 52.9587",
    stroke: "#A6CEE3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -0.0000243187,
    cy: 0.59507,
    rx: 2.4,
    ry: 2.38017,
    fill: "#A6CEE3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 57.1239,
    rx: 2.4,
    ry: 2.38017,
    fill: "#A6CEE3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 38.6777,
    rx: 2.4,
    ry: 2.38017,
    fill: "#A6CEE3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 34.5124,
    rx: 2.4,
    ry: 2.38017,
    fill: "#A6CEE3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 52.9587,
    rx: 2.4,
    ry: 2.38017,
    fill: "#A6CEE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 34.5124C0 34.5124 7.2 54.1487 15 54.1487C22.2 54.1487 22.2 9.52065 30 9.52065C37.2 9.52065 37.2 8.33057 45 8.33057C52.2 8.33057 60 58.9091 60 58.9091",
    stroke: "#1F78B4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -0.0000243187,
    cy: 34.5124,
    rx: 2.4,
    ry: 2.38017,
    fill: "#1F78B4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 54.1488,
    rx: 2.4,
    ry: 2.38017,
    fill: "#1F78B4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 9.52067,
    rx: 2.4,
    ry: 2.38017,
    fill: "#1F78B4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 8.3306,
    rx: 2.4,
    ry: 2.38017,
    fill: "#1F78B4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 58.9091,
    rx: 2.4,
    ry: 2.38017,
    fill: "#1F78B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.92562C0 8.92562 7.2 58.3141 15 58.3141C22.2 58.3141 22.2 30.3471 30 30.3471C37.2 30.3471 37.2 14.281 45 14.281C52.2 14.281 60 0 60 0",
    stroke: "#B2DF8A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -0.0000243187,
    cy: 8.92564,
    rx: 2.4,
    ry: 2.38017,
    fill: "#B2DF8A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 58.3141,
    rx: 2.4,
    ry: 2.38017,
    fill: "#B2DF8A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 30.3471,
    rx: 2.4,
    ry: 2.38017,
    fill: "#B2DF8A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 14.281,
    rx: 2.4,
    ry: 2.38017,
    fill: "#B2DF8A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: -0.0000226498,
    rx: 2.4,
    ry: 2.38017,
    fill: "#B2DF8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0C0 0 7.2 30.3471 15 30.3471C22.2 30.3471 22.2 0.595041 30 0.595041C37.2 0.595041 37.2 27.3719 45 27.3719C52.2 27.3719 60 1.19008 60 1.19008",
    stroke: "#33A02C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -0.0000243187,
    cy: -0.0000226498,
    rx: 2.4,
    ry: 2.38017,
    fill: "#33A02C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 30.3471,
    rx: 2.4,
    ry: 2.38017,
    fill: "#33A02C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 0.59507,
    rx: 2.4,
    ry: 2.38017,
    fill: "#33A02C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 27.3719,
    rx: 2.4,
    ry: 2.38017,
    fill: "#33A02C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 1.1901,
    rx: 2.4,
    ry: 2.38017,
    fill: "#33A02C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.4959C0 12.4959 7.2 8.33057 15 8.33057C22.2 8.33057 22.2 57.124 30 57.124C37.2 57.124 37.2 36.2975 45 36.2975C52.2 36.2975 60 36.2975 60 36.2975",
    stroke: "#FB9A99",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -0.0000243187,
    cy: 12.4959,
    rx: 2.4,
    ry: 2.38017,
    fill: "#1F78B4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 8.3306,
    rx: 2.4,
    ry: 2.38017,
    fill: "#1F78B4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 57.1239,
    rx: 2.4,
    ry: 2.38017,
    fill: "#1F78B4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 36.2975,
    rx: 2.4,
    ry: 2.38017,
    fill: "#1F78B4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 36.2975,
    rx: 2.4,
    ry: 2.38017,
    fill: "#1F78B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.19006C0 1.19006 7.2 55.3388 15 55.3388C22.2 55.3388 22.2 33.9173 30 33.9173C37.2 33.9173 37.2 6.54544 45 6.54544C52.2 6.54544 60 27.3719 60 27.3719",
    stroke: "#E31A1C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -0.0000243187,
    cy: 1.1901,
    rx: 2.4,
    ry: 2.38017,
    fill: "#E31A1C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 55.3388,
    rx: 2.4,
    ry: 2.38017,
    fill: "#E31A1C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 33.9173,
    rx: 2.4,
    ry: 2.38016,
    fill: "#E31A1C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 6.54545,
    rx: 2.4,
    ry: 2.38017,
    fill: "#E31A1C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 27.3719,
    rx: 2.4,
    ry: 2.38017,
    fill: "#E31A1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.57025C0 3.57025 7.2 49.9835 15 49.9835C22.2 49.9835 22.2 32.7273 30 32.7273C37.2 32.7273 37.2 27.9669 45 27.9669C52.2 27.9669 60 20.2314 60 20.2314",
    stroke: "#FDBF6F",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -0.0000243187,
    cy: 3.57023,
    rx: 2.4,
    ry: 2.38017,
    fill: "#A6CEE3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 49.9835,
    rx: 2.4,
    ry: 2.38017,
    fill: "#A6CEE3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 32.7273,
    rx: 2.4,
    ry: 2.38016,
    fill: "#A6CEE3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 27.967,
    rx: 2.4,
    ry: 2.38017,
    fill: "#A6CEE3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 20.2314,
    rx: 2.4,
    ry: 2.38017,
    fill: "#A6CEE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_2713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 58.9091,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletterWidget2);
export default __webpack_public_path__ + "static/media/newsletterWidget2.f8f0e7f0c21cbb4c03c64d746d89e74f.svg";
export { ForwardRef as ReactComponent };